import { render } from "./App.vue?vue&type=template&id=6d3d6ba2"
const script = {}

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__